module.exports = __webpack_public_path__ + "static/media/logo_ard-ci_neg.8342ab51.svg";